import { MeditationRetreatStatus } from "@/constants";
import dayjs from "dayjs";

export * from "./MeditationRetreatList";
export * from "./MeditationRetreatsByLevel";
export * from "./MeditationRetreatsByYear";
export * from "./MeditationRetreatsTable";

export const getMeditationRetreatsStatus = (record: MeditationRetreat) => {
    const isEnded = dayjs(record?.toDate).isBefore(dayjs());
    const isOngoing = dayjs(record?.fromDate).isBefore(dayjs()) && dayjs(record.toDate).isAfter(dayjs());
    const isUpcoming = dayjs(record?.fromDate).isAfter(dayjs());

    switch (true) {
        case isEnded:
            return MeditationRetreatStatus.ENDED;
        case isOngoing:
            return MeditationRetreatStatus.ONGOING;
        case isUpcoming:
            return MeditationRetreatStatus.UPCOMING;
        default:
            return MeditationRetreatStatus.ENDED; // Default fallback
    }
}